import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Trophy, CreditCard } from "lucide-react";

export const HeroSection = () => {
  return (
    <section className="relative min-h-screen pt-20 overflow-hidden" data-testid="hero-section">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/bamboo-bg.avif')" }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-white/70"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="text-sm font-semibold tracking-widest text-teal-700 uppercase bg-white/80 px-3 py-1 rounded-full">
                Empowering Women & Girls
              </span>
            </div>
            
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight">
              <span className="text-slate-800">Your Journey to</span>
              <br />
              <span className="text-terracotta">Independence</span>
              <span className="text-slate-800"> Starts Here</span>
            </h1>
            
            <p className="text-base sm:text-lg text-slate-700 max-w-xl leading-relaxed bg-white/60 p-4 rounded-xl backdrop-blur-sm">
              NokMechik connects unemployed women with trade skills and financial support, 
              while providing dropout girls access to quality home schooling and online education.
            </p>
            
            <div className="flex flex-wrap gap-3 sm:gap-4">
              <Link to="/register">
                <Button size="lg" className="bg-terracotta hover:bg-terracotta/90 text-white rounded-full px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg group shadow-lg" data-testid="hero-join-btn">
                  Register Now
                  <ArrowRight className="ml-2 w-4 sm:w-5 h-4 sm:h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Link to="/login">
                <Button size="lg" variant="outline" className="rounded-full px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg border-2 border-slate-300 hover:border-teal-600 hover:text-teal-700" data-testid="hero-login-btn">
                  I Have an Account
                </Button>
              </Link>
            </div>
            
            {/* Quick Links - Below I Have an Account */}
            <div className="flex flex-wrap items-center gap-2 pt-2">
              <Link to="/competitions">
                <Button variant="ghost" className="flex items-center gap-2 text-purple-700 hover:text-purple-800 hover:bg-purple-50 rounded-full" data-testid="hero-competitions-btn">
                  <Trophy className="w-4 h-4" />
                  Competitions
                </Button>
              </Link>
              <Link to="/payment">
                <Button variant="ghost" className="flex items-center gap-2 text-green-700 hover:text-green-800 hover:bg-green-50 rounded-full" data-testid="hero-payment-btn">
                  <CreditCard className="w-4 h-4" />
                  Payment
                </Button>
              </Link>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="/images/hero-girls.jpg" 
                alt="Girls in traditional attire" 
                className="w-full h-auto object-cover"
                data-testid="hero-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
